import { useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const useStoreItemByIdsQuery = (companyId: string, gameId: string, ids: string[]) => {
  return useQuery({
    enabled: ids.length > 0,
    queryKey: ['store_items_ids', gameId, ids],
    select: response => response.data,
    queryFn: () =>
      dashboardClient.v1.getStoreItemsByIds({
        companyId,
        gameId,
        ids: ids.join(','),
      }),
  })
}
